import {
  BrandTilesItem,
  BrandTilesSlice,
} from '@adapters/prismic/types/brandedStorePage';
import { BrandTile, BrandTilesData } from '_components/BrandTiles/types';

const toTile =
  (defaultCtaLabel: string | null) =>
  (item: BrandTilesItem): BrandTile | null => {
    const url = item.link?.trim();
    const logoUrl = item.logo?.url;
    const imageUrl = item.card_image?.url;
    const coOpBrand = item.co_op_brand?.trim() || null;
    const ctaLabel = item.cta_label?.trim() || defaultCtaLabel;

    const name =
      (logoUrl ? item.logo?.alt?.trim() : item.card_image?.alt?.trim()) ||
      coOpBrand;

    if (!url || !name) return null;

    const base = { url, name, coOpBrand, ctaLabel };

    if (logoUrl) {
      return {
        ...base,
        logo: { url: logoUrl },
        image: imageUrl ? { url: imageUrl } : null,
      };
    }

    if (imageUrl) {
      return { ...base, logo: null, image: { url: imageUrl } };
    }

    return null;
  };

const mapBrandTilesData = (
  primary: BrandTilesSlice['primary'] | undefined,
  items: BrandTilesItem[] | undefined
): BrandTilesData => {
  return {
    heading: primary?.title?.trim() ?? '',
    tiles: (items ?? [])
      .map(toTile(primary?.cta_label?.trim() || null))
      .filter((tile): tile is BrandTile => tile !== null),
  };
};

export default mapBrandTilesData;
